module.exports = __webpack_public_path__ + "static/media/galerija_2021 (27)-min.b0f4834c.jpg";